import { UI, HStack, Stack, VStack } from '@genial/components';
import { BoxBorder, Color, Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';
import { FlatList } from 'react-native';

import { ContractedProductItem, ContractedProductItemLoading } from '../ContractedProductItem';

import { ContractedProductsTypes } from '.';

export const ItemDesktopWrapper: React.FC = () => (
  <Box w="full" h="1px" bgColor={Color['neutral.lightest']} />
);

export const ContractedProductsDesktop: React.FC<ContractedProductsTypes.Props> = ({
  isLoading,
  products,
}) => {
  const renderProducts = () => {
    if (isLoading) {
      return (
        <HStack justifyContent="space-between">
          {Array.from({ length: 3 }).map((_, index) => (
            <ContractedProductItemLoading key={index} />
          ))}
        </HStack>
      );
    }
    return (
      <FlatList
        data={products}
        showsVerticalScrollIndicator={false}
        numColumns={3}
        columnWrapperStyle={{
          paddingVertical: Utils.Token.ToInt(Spacing, 'stack.nano'),
        }}
        renderItem={({ item }) => (
          <Stack w="1/3">
            <ContractedProductItem
              key={item.productName}
              productName={item.productName}
              contracted={item.contracted}
            />
          </Stack>
        )}
      />
    );
  };

  return (
    <UI.Shadow
      level={1}
      borderRadius={BoxBorder.heavy}
      my={Spacing['inset.sm']}
      paddingX={Spacing['inline.xxxs']}
      paddingY={Spacing['inline.xxs']}>
      <VStack space={Spacing['stack.xxs']}>
        <UI.Text fontWeight="bold" color="neutral.darkest">
          Produtos Contratados
        </UI.Text>
        <Box width="full" borderTopWidth={1} borderColor={Color['neutral.lightest']} />
        {renderProducts()}
      </VStack>
    </UI.Shadow>
  );
};
